import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-energie-projecten',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconEnergieProjecten {

  render() {
    return (
      <svg data-name="Layer 1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M8.67 20.06a1 1 0 0 1-1-1v-6h-5c-.38 0-.72-.21-.89-.55s-.14-.74.08-1.04l8-11c.25-.35.71-.5 1.12-.36a1 1 0 0 1 .69.95v6h5c.38 0 .72.21.89.55s.14.74-.08 1.04l-8 11c-.19.26-.5.41-.81.41m-4.03-9h4.04c.55 0 1 .45 1 1v3.92l5.04-6.93h-4.04c-.55 0-1-.45-1-1V4.13z"/>
</svg>

    );
  }
}
